import { queryOptions } from "@tanstack/react-query";

import { listHardwareSensorsForOrg } from "../api/endpoints/sensors";
import { callOptionsHeaders } from "../api/helpers";

type HardwareSensorsOptionsParams = {
  regionCode: string;
  roleId: string;
};

export function hardwareSensorsOptions({
  regionCode,
  roleId,
}: HardwareSensorsOptionsParams) {
  return queryOptions({
    queryKey: ["hardwareSensors", regionCode, roleId],
    queryFn: () =>
      listHardwareSensorsForOrg(
        { orgId: roleId },
        callOptionsHeaders(regionCode, roleId),
      ),
    staleTime: 60 * 1000,
  });
}
